import { Link } from "react-router-dom";
import SocialHandles from "./SocialHandles";
import credentials from "../assets/credentials";
import { HashLink } from "react-router-hash-link";
const Footer = () => {
  const assetLinks = [
    { name: "Linkedin Accounts", link: "/linkedin/accounts" },
    { name: "YouTube Channels", link: "/youtube/channels" },
    { name: "Websites & Domains", link: "/domain" },
  ];

  const companyLinks = [
    { name: "About Us", link: "/about" },
    { name: "Our Mission", link: "/about#mission" },
    { name: "Careers", link: "/careers" },
  ];

  const supportLinks = [
    { name: "Help Center", link: "/help" },
    { name: "Contact Support", link: "/contact" },
    { name: "Privacy Policy", link: "/privacy-policy" },
    { name: "Terms of Use", link: "/terms-conditions" },
  ];

  return (
    <footer className="bg-gray-900 text-white py-12 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand & Social */}
        <div>
          <h2 className="text-2xl font-bold text-purple-500">
            {credentials.appName}
          </h2>
          <p className="mt-3 text-gray-400 text-sm leading-relaxed">
            Discover trusted digital assets from verified sellers — grow your
            online presence securely with {credentials.appName}.
          </p>
          <div className="mt-5">
            <SocialHandles />
          </div>
        </div>

        {/* Explore Assets */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-purple-400">
            Explore Assets
          </h3>
          <ul className="space-y-2 text-gray-400">
            {assetLinks.map(({ name, link }) => (
              <li key={name}>
                <Link
                  to={`/assets/categories${link}`}
                  className="hover:text-purple-400 transition-colors"
                >
                  {name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Company */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-purple-400">
            Company
          </h3>
          <ul className="space-y-2 text-gray-400">
            {companyLinks.map(({ name, link }, index) =>
              name === "Our Mission" ? (
                <li key={name}>
                <HashLink smooth to="/about#mission">
                 Our Mission
                </HashLink>
                </li>
              ) : (
                <li key={name}>
                  <Link
                    to={link}
                    className="hover:text-purple-400 transition-colors"
                  >
                    {name}
                  </Link>
                </li>
              ),
            )}
          </ul>
        </div>

        {/* Support */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-purple-400">
            Support
          </h3>
          <ul className="space-y-2 text-gray-400">
            {supportLinks.map(({ name, link }) => (
              <li key={name}   className="hover:text-purple-400 transition-colors">
                <Link
                  to={link}
                  className="hover:text-purple-400 transition-colors"
                >
                  {name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mb-4 border-t border-gray-800 pt-6 text-center text-sm text-gray-500">
        <p>
          &copy; {new Date().getFullYear()} {credentials.appName} — Empowering
          Digital Growth.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
